// dependencies
import React from "react";

import { SelectOption } from "..";
// Components
import Text from "../../../Text";
// styles
import css from "../AjaxInput.module.scss";

/**
 * The default option component is used to render the default options in the
 * dropdown menu.
 */
export const DefaultOption = (option: SelectOption) => {
	return (
		<div className={css.defaultOption}>
			<Text size="paragraph-3" weight="regular" className={css.name}>
				{option.label}
			</Text>
		</div>
	);
};

/**
 * The goal outlook option component is used to render the goal outlook options
 * including the color of the goal outlook
 */
export const GoalOutlookOption = (category) => {
	return (
		<div className={css.defaultOption}>
			<div className={css.outlookColor} style={{ backgroundColor: category.color }} />
			<Text size="paragraph-3" weight="regular" className={css.name}>
				{category.label}
			</Text>
		</div>
	);
};
